import { SERVICE_UID } from "@/types";

export const useRequestAuth = () => {
  const addAuthScript = () => {
    const scriptUrl = process.env.VUE_APP_AUTH_SCRIPT_URL;

    if (document.querySelector(`script[src="${scriptUrl}"]`)) return;

    const recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("src", `${scriptUrl}`);
    document.head.appendChild(recaptchaScript);
  };

  const requestAuth = (path: string) => {
    window.eziok_std_process(
      `${process.env.VUE_APP_API_URL}/aibos/client/api/v1/public/service/${SERVICE_UID}/auth/eziok/${path}`,
      "MB",
      ""
    );
  };

  return { addAuthScript, requestAuth };
};
